import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProductsTableRow from './ProductsTableRow';
import { Card } from '@dart-design/core';
import { withRouter } from 'react-router';

const CAPITAL_HELP_TIP =
  'Capital is the total investment in long term assets that will be added to the balance sheet and depreciated over time.';

const EXPENSE_HELP_TIP =
  'Not all project costs can be capitalized and must be treated as expensed in the business year in which they are incurred. Examples include project oversight, installation, travel, demolition, and others.';

const DURATION_HELP_TIP =
  'Duration is the projected timeframe, in weeks, from Blast Email to product ready to build inventory. Each product duration is specific to that product, and work will be done concurrently.';

class ProductsTable extends Component {
  static propTypes = {
    products: PropTypes.array
  };

  static defaultProps = {
    products: []
  };

  render() {
    return(
      <div>
        <div className="products-table-scroll">
          <div className="list products-table-grid">
            <div className="header hidden-xs products-table-header">
              <div className="row">
              <div className="col-sm-2">Product</div>
              <div className="col-sm-2">Print & Color</div>
              <div className="col-sm-1">Product Category & Material(s)</div>
              <div className="col-sm-1">Producing Plant</div>
              <div className="col-sm-1">Annual Volume (M)</div>
              <div className="col-sm-2">Packaging Specs</div>
              <div className="col-sm-1">
                Capital (USD){' '}
                <FontAwesomeIcon icon={faInfoCircle} style={{color: '#024c82'}}
                  title={CAPITAL_HELP_TIP} />
              </div>
              <div className="col-sm-1">
                Expense (USD){' '}
                <FontAwesomeIcon icon={faInfoCircle} style={{color: '#024c82'}}
                  title={EXPENSE_HELP_TIP}
                />
              </div>
              <div className="col-sm-1">
                Duration (Weeks){' '}
                <FontAwesomeIcon icon={faInfoCircle} style={{color: '#024c82'}}
                  title={DURATION_HELP_TIP}
                />
              </div>
              <div className="col-edit-button"></div>
              </div>
            </div>
            { this.renderRows() }
          </div>
        </div>
      </div>
    );
  }

  renderRows() {
    if (this.props.products.length === 0) {
      return <Card>
        <div className="space-inset-lg" style={{textAlign: 'center'}}>
          No products have been added yet
        </div>
      </Card>;
    }

    return this.props.products.map(product => {
      return <ProductsTableRow product={product} key={product.id}
        request={this.props.request}
        disabled={this.props.disabled}/>;
    });
  }
}

export default withRouter(ProductsTable);
